import { parse, intervalToDuration } from "date-fns";

export default function calculateAge(dob) {
  const birthDate = parse(dob, "yyyy-MM-dd", new Date());
  const detailedAge = intervalToDuration({ start: birthDate, end: new Date() });
  return detailedAge.years;
}
